import React, { FC, PropsWithChildren } from 'react';

import { useGlobalFetchErrors } from './useGlobalFetchErrors';
import { ErrorBoundary } from './ErrorBoundary';

/**
 * Global error handling.
 *
 * split up into a fn and a class component so we can take advantage of the `componentDidCatch` method.
 */
export const CatchErrors: FC<PropsWithChildren> = ({ children }) => {
  const { getAccountError, getProfileError } = useGlobalFetchErrors();
  return (
    <ErrorBoundary
      getAccountError={getAccountError}
      getProfileError={getProfileError}
    >
      {children}
    </ErrorBoundary>
  );
};
